module.exports = __webpack_public_path__ + "img/hover-iocn1.b7b39613.svg";